/**
 * Íconos de la UI de nivelación (portados del bundle: onboarding-screens.jsx,
 * level-data.jsx, progress-screens.jsx). Tipados, sin `Object.assign(window)`.
 */

interface IconProps {
  size?: number;
}

export function IconCheck({ size = 14 }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
      <path d="M5 12 L 10 17 L 19 7" />
    </svg>
  );
}

export function IconArrow({ size = 18 }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M5 12 H 19" />
      <path d="M13 6 L 19 12 L 13 18" />
    </svg>
  );
}

interface ChevronProps extends IconProps {
  dir?: 'up' | 'down';
}

export function IconChevron({ size = 18, dir = 'down' }: ChevronProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      stroke="currentColor"
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ transform: dir === 'up' ? 'rotate(180deg)' : 'none', transition: 'transform 0.25s ease' }}
    >
      <path d="M6 9 L 12 15 L 18 9" />
    </svg>
  );
}

export function IconBack({ size = 18 }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M15 6 L 9 12 L 15 18" />
    </svg>
  );
}

export function IconWand({ size = 16 }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
      <path d="M5 19 L 16 8" />
      <path d="M14 6 L 18 10" />
      <path d="M18 3 l 0.6 1.6 L 20 5 l -1.4 0.6 L 18 7 l -0.6 -1.4 L 16 5 l 1.4 -0.4 Z" fill="currentColor" stroke="none" />
      <path d="M5 4 l 0.4 1 L 6.4 5.4 l -1 0.4 L 5 6.8 l -0.4 -1 L 3.6 5.4 l 1 -0.2 Z" fill="currentColor" stroke="none" />
    </svg>
  );
}

export function IconClock({ size = 13 }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="9" />
      <path d="M12 7 V 12 L 15 14" />
    </svg>
  );
}

export function IconChat({ size = 13 }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 12 a 9 9 0 0 1 -13 8 L 3 21 L 4 17 A 9 9 0 1 1 21 12 Z" />
    </svg>
  );
}

export function IconHeart({ size = 14 }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="currentColor">
      <path d="M12 21 C 6 16, 3 12, 3 8.5 A 4 4 0 0 1 12 6 A 4 4 0 0 1 21 8.5 C 21 12, 18 16, 12 21 Z" />
    </svg>
  );
}

export function IconShield({ size = 14 }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 3 L 20 6 V 11 c 0 5 -3.5 8 -8 10 c -4.5 -2 -8 -5 -8 -10 V 6 Z" />
    </svg>
  );
}

export function IconWifiOff({ size = 30 }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 3 L 21 21" />
      <path d="M5 9 a 14 14 0 0 1 5 -2.8" />
      <path d="M14 6.4 A 14 14 0 0 1 19 9" />
      <path d="M8.5 12.5 a 8 8 0 0 1 3 -1.4" />
      <path d="M14 11.4 a 8 8 0 0 1 1.5 1" />
      <path d="M12 18 h 0.01" />
    </svg>
  );
}

export function IconAlert({ size = 30 }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 3 L 22 20 H 2 Z" />
      <path d="M12 10 V 14" />
      <path d="M12 17 h 0.01" />
    </svg>
  );
}

export function IconFlag({ size = 14 }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M5 21 V 4" />
      <path d="M5 4 H 17 L 14 8 L 17 12 H 5" fill="currentColor" stroke="none" />
    </svg>
  );
}
